// Notice.js

import React, { Component } from 'react';
import { Button, Form, Table } from 'react-bootstrap';
import Config from '../Config';
import ScrollArea from 'react-scrollbar';
import Modal from 'react-awesome-modal';

import AutoSizer from 'react-virtualized/dist/commonjs/AutoSizer';
import Column from 'react-virtualized/dist/commonjs/Table/Column';
import GTable from 'react-virtualized/dist/commonjs/Table';
import SortDirection from 'react-virtualized/dist/commonjs/Table/SortDirection';
import SortIndicator from 'react-virtualized/dist/commonjs/Table/SortIndicator';
import styles from './Table.css';

class NoticeItem extends Component {
    static defaultProps = {
        item: null,
        enable: false,
        onPress: () => { },
    }
    constructor(props) {
        super(props);
        this.state = {
            answervisible: false
        };
    }

    handleRowClick = () => {
        this.props.onPress(this.props.item);
        event.preventDefault();
    }
    render() {
        return (
            <tr onClick={this.handleRowClick}>
                <td>{this.props.item.ID}</td>
                <td>{this.props.item.TITLE}</td>
                <td>{this.props.item.CONTENT}</td>
                <td>{this.props.item.LANG}</td>
                <td>{this.props.item.REGDATE}</td>
            </tr>
        );
    }
};

export default class Notice extends Component {
    constructor(props) {
        super(props);
        this.default = { TITLE: '제목을 입력하세요.', CONTENT: '내용을 입력하세요.', LANG: Config.defaultLANG };
        this.state = {
            sendcount: 0,
            noticelist: [],
            answervisible: false,
            scrollToIndex: undefined,
            item: { ...this.default }
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleChangeContent = this.handleChangeContent.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleReset = this.handleReset.bind(this);
        this.handleRemove = this.handleRemove.bind(this);
        this.handleChangeLang = this.handleChangeLang.bind(this);
    }

    handleReset(event) {
        this.setState({ item: { ...this.default } })
    }

    handleChange(event) {
        var item = this.state.item;
        item.TITLE = event.target.value;
        this.setState({ item: item });
    }

    handleChangeContent(event) {
        var item = this.state.item;
        item.CONTENT = event.target.value;
        this.setState({ item: item });
    }

    handleChangeLang(event) {
        var item = this.state.item;
        item.LANG = event.target.value;
        this.setState({ item: item });
    }

    handleChangeCountry(event) {
        this.setState({ country: event.target.value });
    }

    fetchData(address, params, callback, revalidate = false, cbError) {

        var chcheoption = {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        };

        if (revalidate) {
            // chcheoption['Cache-Control'] = 'must-revalidate';
        }

        fetch(`${Config.Server}/${address}`, {
            // mode: 'no-cors',
            method: 'POST',
            headers: chcheoption,
            body: JSON.stringify(params)
        })
            .then((response) => response.json())
            .then((responseJson) => {
                console.log(responseJson);
                if (callback)
                    callback(responseJson.result, responseJson.count);
            })
            .catch((error) => {
                console.error(error);
                cbError(error);
            });
    }

    handleSubmit(event) {

        this.fetchData('insnotice', {
            LANG: this.state.item.LANG,
            TITLE: this.state.item.TITLE,
            CONTENT: this.state.item.CONTENT
        }, (result, count) => {
            console.log('insnotice=', count);
            this.setState({ sendcount: count })
            this.componentDidMount();

        }, true);

        event.preventDefault();
    }

    handleRemove(event) {

        this.fetchData('delnotice', {
            ID: this.state.item.ID,
            LANG: this.state.item.LANG
        }, (result, count) => {
            console.log('delnotice=', count);
            this.setState({ sendcount: count })
            this.componentDidMount();

        }, true);

        event.preventDefault();
    }

    handleRowClick = (event) => {
        var item = event.rowData;
        console.log(item);
        var edititem = { ...item };
        edititem.TITLE = item.TITLE;
        edititem.CONTENT = item.CONTENT;
        this.setState({ item: edititem });
        this.setState({ answervisible: true });
        event.preventDefault();
    }

    componentDidMount() {
        this.fetchData('noticeall', {
        }, (result, count) => {
            console.log('count=', count);
            this.setState({ noticelist: result })
        }, true);
    }

    handleNew() {
        this.handleReset(null);
        this.setState({ answervisible: true });
    }

    handleScroll(scrollData) {
        console.log(scrollData);
    }

    handleClose = () => {
        console.log('handleClose');
        this.setState({ answervisible: false });
    }

    _noRowsRenderer() {
        return <div>No rows</div>;
    }

    _onScrollToRowChange(event) {
        const { rowCount } = this.state;
        let scrollToIndex = Math.min(
            rowCount - 1,
            parseInt(event.target.value, 10),
        );

        if (isNaN(scrollToIndex)) {
            scrollToIndex = undefined;
        }

        this.setState({ scrollToIndex });
    }

    _rowClassName({ index }) {
        if (index < 0) {
            return "headerRow";
        } else {
            return index % 2 === 0 ? "evenRow" : "oddRow";
        }
    }

    render() {
        let scrollbarStyles = { borderRadius: 5 };
        return (
            <div className="content-wrapper">
                <section className="content-header">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="box">
                                <div className="box-header with-border">
                                    <table>
                                        <tr>
                                            <td>
                                                <h3 className="box-title">공지사항 등록</h3>
                                            </td>
                                            <td>
                                                <div className="row" style={{ margin: 16 }}>
                                                    <Button variant="primary" onClick={this.handleNew.bind(this)}>신규</Button>
                                                </div>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                                <div className="box-body" style={{ margin: 20 }}>
                                    <div className="row">
                                        <AutoSizer disableHeight>
                                            {({ width }) => (
                                                <GTable
                                                    ref="Table"
                                                    headerClassName={'headerColumn'}
                                                    onRowClick={this.handleRowClick}
                                                    headerHeight={30}
                                                    height={800}
                                                    noRowsRenderer={this._noRowsRenderer}
                                                    overscanRowCount={10}
                                                    rowClassName={this._rowClassName}
                                                    rowHeight={40}
                                                    rowGetter={({ index }) => this.state.noticelist[index]}
                                                    rowCount={this.state.noticelist.length}
                                                    scrollToIndex={this.state.scrollToIndex}
                                                    width={width}>
                                                    <Column
                                                        width={100}
                                                        disableSort
                                                        label="#"
                                                        dataKey="ID"
                                                        className={'exampleColumn'}
                                                        cellRenderer={({ cellData }) => cellData}
                                                        flexGrow={1}
                                                    />
                                                    <Column
                                                        width={400}
                                                        disableSort
                                                        label="제목"
                                                        dataKey="TITLE"
                                                        className={'exampleColumn'}
                                                        cellRenderer={({ cellData }) => cellData}
                                                        flexGrow={1}
                                                    />
                                                    <Column
                                                        width={600}
                                                        disableSort
                                                        label="내용"
                                                        dataKey="CONTENT"
                                                        className={'exampleColumn'}
                                                        cellRenderer={({ cellData }) => cellData}
                                                        flexGrow={1}
                                                    />
                                                    <Column
                                                        width={100}
                                                        disableSort
                                                        label="언어"
                                                        dataKey="LANG"
                                                        className={'exampleColumn'}
                                                        cellRenderer={({ cellData }) => cellData}
                                                        flexGrow={1}
                                                    />
                                                    <Column
                                                        width={150}
                                                        disableSort
                                                        label="등록일"
                                                        dataKey="REGDATE"
                                                        className={'exampleColumn'}
                                                        cellRenderer={({ cellData }) => cellData}
                                                        flexGrow={1}
                                                    />
                                                </GTable>
                                            )}
                                        </AutoSizer>
                                        {/* <ScrollArea style={{  width: '100%' , height: 700 }}
                                            className="area"
                                            contentClassName="content"
                                            verticalScrollbarStyle={scrollbarStyles}
                                            verticalContainerStyle={scrollbarStyles}
                                            horizontalScrollbarStyle={scrollbarStyles}
                                            horizontalContainerStyle={scrollbarStyles}
                                            smoothScrolling= {true}
                                            minScrollSize={5}
                                            onScroll={this.handleScroll}
                                            >
                                        <Table striped bordered hover>
                                        <thead>
                                            <tr>
                                            <th>#</th>
                                            <th>제목</th>
                                            <th>내용</th>
                                            <th>언어</th>
                                            <th>등록일</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                        { this.state.noticelist.map((item, index) =>
                                            <NoticeItem key={index} item={item} onPress={this.handleRowClick}/>
                                        )}
                                        </tbody>
                                        </Table>
                                        </ScrollArea> */}
                                    </div>
                                    <div className="row">
                                        <Modal visible={this.state.answervisible} width="80%" effect="fadeInUp" onClickAway={() => this.handleClose()}>
                                            <div style={{ margin: 20 }}>
                                                <h2>공지사항 등록</h2>
                                                <Form>
                                                    <Form.Group controlId="exampleForm.ControlInput1">
                                                        <Form.Label>제목</Form.Label>
                                                        <Form.Control type="title" placeholder="제목을 입력하세요." value={this.state.item.TITLE} onChange={this.handleChange} />
                                                    </Form.Group>
                                                    <Form.Group controlId="exampleForm.ControlSelect1">
                                                        <Form.Label>언어선택</Form.Label>
                                                        <Form.Control as="select" value={this.state.item.LANG} onChange={this.handleChangeLang}>
                                                            {Config.ProductLangs.map((item, index) =>
                                                                <option key={index}>{item}</option>
                                                            )}
                                                        </Form.Control>
                                                    </Form.Group>
                                                    <Form.Group controlId="exampleForm.ControlTextarea1">
                                                        <Form.Label>내용</Form.Label>
                                                        <Form.Control as="textarea" rows="10" value={this.state.item.CONTENT} onChange={this.handleChangeContent} />
                                                    </Form.Group>
                                                    <Button variant="primary" onClick={this.handleSubmit}>등록</Button>
                                                    <Button variant="primary" onClick={this.handleReset}>리셋</Button>
                                                    <Button variant="primary" onClick={this.handleRemove}>삭제</Button>
                                                </Form>
                                                <Button variant="primary" onClick={this.handleClose}>Close</Button>
                                            </div>
                                        </Modal>
                                    </div>
                                </div>
                                <div className="box-footer">
                                    <div className="row">
                                        <div className="col-sm-3 col-xs-6">
                                            <div className="description-block border-right">
                                                {/* <span className="description-percentage text-green"><i className="fa fa-caret-up"></i> 17%</span> */}
                                                {/* <h5 className="description-header">Sending TOTAL: {this.state.sendcount}</h5> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        )
    }
}




// WEBPACK FOOTER //
// src/components/Notice.js